
export type TOption = {
  title: string;
  advantages: { title?: string; descr: string }[];
  disadvantages: { title?: string; descr: string }[];
  footer?: { title: string; descr: string };
  action: string;
  eventLabel: string;
  ofertaUrl?: string;
};

export function getOptions(ofertaUrl: string, homeownerSubscriptionPaymentEnabled: boolean): TOption[] {

  return [
    {
      title: 'С бесплатными сервисами от Циан',
      advantages: [
        {
          title: 'Вы выбираете арендаторов из анкет',
          descr: 'Мы продвигаем ваше объявление и сами принимаем все звонки',
        },
        {
          title: 'Поможем оформить легальную аренду',
          descr: 'Легальная аренда без потери в доходах — сдадим квартиру дороже на сумму налога',
        },
        {
          title: 'Вместо залога полное страхование',
          descr: 'Предоставим гарантии от любого урона жильцом и его внезапного съезда',
        },
        {
          title: 'Безопасный онлайн договор',
          descr: 'Договор составленный нашими юристами. Проверим документы арендатора перед подписанием',
        },
      ],
      disadvantages: [],
      footer: {
        title: homeownerSubscriptionPaymentEnabled
          ? 'Стоимость сервиса'
          : 'Для вас сервис бесплатный',
        descr: homeownerSubscriptionPaymentEnabled
          ? '1 990 ₽ в месяц, ничего не спишем, пока не заключён договор. Никакой комиссии с арендаторов.'
          : 'Для арендатора единоразовая комиссия 15% и ежемесячная подписка 990 ₽',
      },
      action: 'applyDealRent',
      eventLabel: 'deal_safe_rent_with_help',
      ofertaUrl,
    },
    {
      title: 'Сдам сам',
      advantages: [
        {descr: 'Бесплатно для собственника'},
      ],
      disadvantages: [
        {descr: 'Ваше объявление в поиске расположено после всех проплаченных'},
        {descr: 'Ваш номер видят все — и посредники, и неподходящие арендаторы'},
        {descr: 'Вы защищены только суммой залога'},
        {descr: 'Не оплачивая налоги вы менее защищены'},
      ],
      action: 'goNext',
      eventLabel: 'deal_safe_rent_without_help',
    },
  ];
}
